import { useEffect, useState } from 'react';

import { EmcNeedHelp } from '@components';
import { Button } from '@elements/button';
import { Checkbox } from '@elements/checkbox';
import { Notification } from '@elements/notification';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useBoostDetailsStore, useEmcStore } from '@store';
import { sendAnalyticsEvent, testProps } from '@utils';

import { QuestionList } from './questionList.component';

export const EmcPreAssessment = () => {
  const [hasAgreedPrivacyNotice, setHasAgreedPrivacyNotice] = useState(false);
  const [hasAttemptedContinue, setHasAttemptedContinue] = useState(false);
  const screeningQuestions = useEmcStore(state => state.screeningQuestions);
  const emcDeclaring = useBoostDetailsStore(state => state.emcDeclaring);

  const hasIncompleteQuestions = screeningQuestions.some(it => it.hasSelectedNo !== true);

  const setOpenEmcSection = useEmcStore(state => state.setOpenEmcSection);

  const onButtonClick = () => {
    setHasAttemptedContinue(true);

    if (!hasAgreedPrivacyNotice || hasIncompleteQuestions) {
      return;
    }
    window.document?.getElementById('slide-modal-content')?.scrollTo(0, 0);
    return setOpenEmcSection('assessment');
  };

  useEffect(() => {
    sendAnalyticsEvent('Pre-assessment page landed', {
      TravellerID: emcDeclaring?.travellerId ?? '',
    });
  }, [emcDeclaring?.travellerId]);

  const showPrivacyError = hasAttemptedContinue && !hasAgreedPrivacyNotice;
  const showGeneralError =
    hasAttemptedContinue && (hasIncompleteQuestions || !hasAgreedPrivacyNotice);

  return (
    <div className="h-full grid gap-5">
      {showGeneralError ? (
        <Notification
          variant="error"
          header="You haven't selected all the options or accepted Freely policy."
          body="Please select all the options and accept privacy policy"
        />
      ) : null}
      <QuestionList />
      <div className="flex sm:items-start md:items-center mt-4">
        <Checkbox
          name="privacy-notice-confirm"
          className="py-0"
          isChecked={hasAgreedPrivacyNotice}
          onClick={() => {
            setHasAgreedPrivacyNotice(p => !p);
          }}
          labelProps={{
            children: `${i18n.t('emcShared.preAssessment.checkbox.label')}`,
            variant: 'body-16/m',
          }}
          {...testProps('checkbox-pre-assessment')}
          errorMessage={
            showPrivacyError
              ? 'Please confirm that you’ve read and agree to all the statements above to continue.'
              : undefined
          }
        />
      </div>
      <Text variant="body-16/r">{i18n.t('emcShared.preAssessment.summary')}</Text>
      <div className="flex flex-col md:flex-row items-center gap-3 md:justify-end">
        <Button
          className="mt-10 w-full sm:w-auto md:mb-4"
          variant="primary"
          onClick={onButtonClick}
          title={i18n.t('emcShared.preAssessment.button')}
          {...testProps('btn-continue-assessment')}
        />

        <EmcNeedHelp className="sm:hidden mt-3 mb-8" />
      </div>
    </div>
  );
};
